<div class="preview_wrapper">
  <p class="title">Warehouse Name
    <span class="green_circle_tick">
            <img src="../../../../assets/img/white_tick.svg" alt="">
        </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Name</p>
        <p class="value">{{warehouse?.name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Email</p>
        <p class="value">{{warehouse?.email}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Phone </p>
        <p class="value">{{warehouse?.phone}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Fax</p>
        <p class="value">{{warehouse?.fax}}</p>
      </div>
    </div>

  </div>
</div>

<div class="preview_wrapper">
  <p class="title">Warehouse Details
<!--    <span class="green_circle_tick">-->
<!--            <img src="../../../../assets/img/white_tick.svg" alt="">-->
<!--        </span>-->
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Address Line 1</p>
        <p class="value">{{wareHouseDetail?.main_address?.address_line_1}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Address Line 2</p>
        <p class="value">{{wareHouseDetail?.main_address?.address_line_2}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">City</p>
        <p class="value">{{wareHouseDetail?.main_address?.city}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">State</p>
        <p class="value">{{wareHouseDetail?.main_address?.state_id?.name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Zip Code</p>
        <p class="value">{{wareHouseDetail?.main_address?.zipcode}}</p>
      </div>
    </div>

  </div>
</div>
